import Vue from 'vue'
import VueRouter from 'vue-router'
import Layout from '@/layout'
import Home from '../views/home.vue'
import Pledge from '../views/pledge.vue'
import BlindboxDetail from '../views/blindbox/detail.vue'

import Page503 from '../views/503.vue'
import DevelopingPage from '../views/developing.vue'
import Admin from '../views/admin.vue'
Vue.use(VueRouter)

const developRoutes = [
  {
    path: 'rad-to-ai',
    component: DevelopingPage,
    name: 'RadToAi',
    meta: { title: 'RAD兑换Ai算法龙虾燃料' },
  },
  {
    path: 'rusd-defi',
    component: DevelopingPage,
    name: 'RusdDefi',
    meta: { title: 'RUSD增值稳定币DEFI' },
  },
  {
    path: 'chain-game',
    component: DevelopingPage,
    name: 'ChainGame',
    meta: { title: '链上游戏生态' },
  },
  {
    path: 'chain-mall',
    component: DevelopingPage,
    name: 'ChainMall',
    meta: { title: '链上商城生态' },
  },
  {
    path: 'share-swap',
    component: DevelopingPage,
    name: 'ShareSwap',
    meta: { title: '币股同权兑换' },
  },
];

const routes = [
  {
    path: '/',
    component: Layout,
    redirect: 'home',
    children: [
      {
        path: 'home',
        component: Home,
        name: 'Home',
      },
      {
        path: 'pledge',
        component: Pledge,
        name: 'pledge',
      },
      {
        path: 'blindbox/:id',
        component: BlindboxDetail,
        name: 'BlindboxDetail',
      },
      {
        path: 'admin',
        component: Admin,
        name: 'Admin',
        meta: { title: '管理员页面' },
      },
      ...developRoutes,
    ],
  },
  {
    path: '/503',
    component: Page503,
    name: '提示',
  },
]

const router = new VueRouter({
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    }
    return { x: 0, y: 0 };
  },
});

router.afterEach(() => {
  const app = document.getElementById("app");
  if (app) {
    app.scrollTop = 0;
  } else {
    window.scrollTo(0, 0);
  }
});

export default router
